import * as types from './eventTypeTypes';

const initialState = {
  loading: false,
  eventTypes: [],
  errors: null,
};

const eventTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_EVENT_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.LOAD_EVENT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        eventTypes: action.payload?.result || [],
      };

    case types.LOAD_EVENT_TYPES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    default:
      return state;
  }
};

export default eventTypeReducer;

